const STOREFRONT_API_VERSION = '2023-10';

const SHOPIFY_COOKIES = Object.freeze({
  SHOPIFY_Y: '_shopify_y',
  SHOPIFY_S: '_shopify_s',
});

const SHOPIFY_HEADERS = Object.freeze({
  CONTENT_TYPE: 'Content-Type',
  X_SHOPIFY_STOREFRONT_ACCESS_TOKEN: 'X-Shopify-Storefront-Access-Token',
  SHOPIFY_STOREFRONT_Y: 'Shopify-Storefront-Y',
  SHOPIFY_STOREFRONT_S: 'Shopify-Storefront-S',
});

const CONTENT_TYPE_APPLICATION_JSON = 'application/json';

export { STOREFRONT_API_VERSION, SHOPIFY_COOKIES, SHOPIFY_HEADERS, CONTENT_TYPE_APPLICATION_JSON };
